import './Styles/TableLoadingSpinnerStyles.css'

import { AiOutlineLoading3Quarters } from "react-icons/ai"

const TableLoadingSpinner = () => {
    return (<div className="d-flex justify-content-center align-items-center">
        <AiOutlineLoading3Quarters className="animate-spin" size={20} color="var(--primary)" />
    </div>)
}

export default TableLoadingSpinner